import(/* webpackMode: "eager" */ "/app/src/plugins/CustomCss.jsx");
import(/* webpackMode: "eager" */ "/app/src/plugins/GA4.js");
import(/* webpackMode: "eager" */ "/app/src/plugins/LogRocketPlugin.js");
import(/* webpackMode: "eager" */ "/app/src/plugins/Plugins.jsx");
import(/* webpackMode: "eager" */ "/app/src/plugins/StyledJsxRegistry.jsx");
import(/* webpackMode: "eager" */ "/app/src/views/widget/WidgetStart.jsx");
import(/* webpackMode: "eager" */ "/app/src/views/widget/WidgetWrapper.jsx")